import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-24 bg-brand-dark relative" data-id="element-120">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-122">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-center mb-12 text-white" data-id="element-123">
            Si estás leyendo esto,{' '}
            <span className="text-brand-gold italic" data-id="element-124">
              sabes exactamente de qué hablo.
            </span>
          </h2>

          <div className="space-y-8 text-lg text-brand-text/80 leading-relaxed font-light" data-id="element-125">
            <p data-id="element-126">
              Si estás aquí, es porque sabes que algo ha cambiado. Quizás empezó
              como un incidente aislado. Un momento de estrés, un poco de
              cansancio extra...{' '}
              <span className="text-white font-medium" data-id="element-127">
                y de repente, TE SENTISTE FLACIDO.
              </span>
            </p>

            <p data-id="element-128">
              Ese silencio incómodo en la habitación. Esa mirada de tu pareja o
              cita que intentas no ver. Pero lo peor no es eso. Lo peor es el
              pensamiento que te persigue al día siguiente:{' '}
              <strong className="text-brand-crimson font-semibold" data-id="element-129">
                ¿Me volverá a pasar?
              </strong>
            </p>

            <p data-id="element-130">
              La ansiedad de rendimiento es un círculo vicioso. Cuanto más te
              preocupas, más cortisol produces. Y el cortisol es el asesino
              número uno de tu erección. Te sientes menos hombre. Sientes que
              has perdido el control de tu propio cuerpo.
            </p>
          </div>

          <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="mt-12 p-8 border-l-4 border-brand-gold bg-brand-card rounded-r-lg shadow-lg relative overflow-hidden" data-id="element-131">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/5 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-132"></div>
            <p className="text-xl sm:text-2xl font-serif text-white font-medium italic relative z-10" data-id="element-133">
              "Tengo una noticia para ti: No es tu culpa.{' '}
              <span className="text-brand-gold" data-id="element-134">
                Pero sí es tu responsabilidad arreglarlo.
              </span>
              "
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}